import React, { FC, useEffect, useState } from "react";
import { Button, Form, FormControl, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Tooltip } from "react-tippy";
import { reduceEachLeadingCommentRange } from "typescript";
import { Element } from "../../../../models/elementModel";
import { getSession } from "../../../../selectors/appSelectors";
import NavTabs from "./NavTabs";


export interface RenderNavigationProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}
const NavigationElement: FC<RenderNavigationProps> = ({ index, element, isPreview = false, }) => {

  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    setViewRemark(sessionState.viewRemark)
    console.log(sessionState.viewRemark)

  }, [sessionState])

  const defaultStyles = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };

  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end

  return (
    <>
      <Navbar
        bg={element.properties.bg}
        className={`${
          element.properties.display === false ? "blur-element" : ""
        }`}
        style={{
          backgroundColor: element.properties.colour,
          height:
            element.styles.height == "" ||
            element.styles.height == undefined ||
            element.styles.height == "0"
              ? ""
              : element.styles.height + "px",
          width:
            element.styles.width == "" ||
            element.styles.width == undefined ||
            element.styles.width == "0"
              ? ""
              : element.styles.width + "px",
          ...defaultStyles,
          ...styleObj,
        }}
        variant={element.properties.varient}
        expand={element.properties.expand}
      >
        <Navbar.Brand
          style={{
            fontSize:
              element.styles.fontSize === "" ||
              element.styles.fontSize === undefined ||
              element.styles.fontSize === "0"
                ? ""
                : element.styles.fontSize + "pt",
            fontFamily: element.styles.fontFamily,
            color: element.styles.color,
          }}
        >
          {element.properties.brandLogo && (
            <img
              src={element.properties.brandLogo}
              width={
                element.properties.brandLogoSize < 30 ||
                element.properties.brandLogoSize == null ||
                element.properties.brandLogoSize == undefined
                  ? "30"
                  : element.properties.brandLogoSize
              }
              // height="30"
              className="d-inline-block align-top"
              alt={element.properties.brandLogoAlt}
            />
          )}
          <span
            style={{ marginLeft: element.properties.gapBetweenLogo + "px" }}
          >
            {element.properties.brandName}
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <NavTabs
            index={index}
            element={element.properties.tabs}
            actions={element.actions}
          />
          {/* <Form inline>
              <FormControl type="text" placeholder="Search" className="mr-sm-2" />
              <Button variant="outline-success">Search</Button>
            </Form> */}
        </Navbar.Collapse>
      </Navbar>
      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </>
  );
};

export default NavigationElement;